import { StrategyName } from "../types";

export const strategyLabels: Record<StrategyName, string> = {
  // PAYE strategies
  [StrategyName.MaximiseCashInHand]:                     "Maximise Cash In Hand",
  [StrategyName.MinimiseTax]:                            "Minimise Tax",
  [StrategyName.SecureChildBenefit]:                     "Secure Child Benefit",
  [StrategyName.Escape100kTrap]:                         "Escape £100k Trap",
  [StrategyName.SwitchToSalarySacrifice]:                "Switch to Salary Sacrifice",

  // Contractor strategies
  [StrategyName.ContractorBaseline]:                     "Baseline (Maximum Dividends)",
  [StrategyName.ContractorMinimiseTax]:                  "Minimise Tax",
  [StrategyName.ContractorWithFlatRateVAT]:              "Use Flat Rate VAT",
  [StrategyName.ContractorEscape100kTrap]:               "Escape £100k Trap",
  [StrategyName.ContractorSecureChildBenefit]:           "Secure Child Benefit",
  [StrategyName.ContractorEscape90kVATRegistration]:     "Escape £90k VAT Registration",
  [StrategyName.ContractorMarginalReliefOptimisation]:   "Optimise Corporation Tax Rate",
};
